import React from "react";
import axios from "axios";
import { withRouter } from "react-router-dom";
import "../Forms/css/register.css";

const token = localStorage.getItem('authToken');

class EditCoupon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      code: '',
      limit_for_user: '',
      discount_type: 'amount',
      discount_amount: '',
      minimum_purchase: '',
      start_date: '',
      expire_date: '',
      submissionStatus: null,
      id: null,
    };
  }

  componentDidMount() {
    const { match } = this.props;
    if (match && match.params && match.params.id) {
      const { id } = match.params;
      this.setState({ id });
      this.fetchData(id);
    } else {
      console.error("No match or id found in props");
    }
  }

  formatDate(date) {
    if (!date) return '';
    const d = new Date(date);
    return d.toISOString().slice(0, 16); // Format date to 'YYYY-MM-DDTHH:MM'
  }

  fetchData = async (id) => {
    try {
      const response = await axios.get(`https://brand.aasmo.in/api/superadmin/coupons/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const couponData = response?.data;
      if (couponData) {
        this.setState({
          title: couponData?.title || '',
          code: couponData?.code || '',
          limit_for_user: couponData?.user_limit || '',
          discount_type: couponData?.discount_type || 'amount',
          discount_amount: couponData?.discount_amount || '',
          minimum_purchase: couponData?.minimum_purchase || '',
          start_date: this.formatDate(couponData?.start_date) || '',
          expire_date: this.formatDate(couponData?.expiry_date) || '',
        });
      } else {
        console.error("No coupon data found");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { id } = this.state;
    const {
      title,
      code,
      limit_for_user,
      discount_type,
      discount_amount,
      minimum_purchase,
      start_date,
      expire_date
    } = this.state;

    // Convert dates back to ISO format
    const formattedStartDate = new Date(start_date).toISOString();
    const formattedExpireDate = new Date(expire_date).toISOString();

    const couponData = {
      title,
      code,
      user_limit: limit_for_user,
      discount_type,
      discount_amount,
      minimum_purchase,
      start_date: formattedStartDate,
      expiry_date: formattedExpireDate,
    };

    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        }
      };
      const response = await axios.put(`https://brand.aasmo.in/api/superadmin/coupons/${id}`, couponData, config);
      if (response && response.status === 200) {
        this.setState({ submissionStatus: 'success' });
        setTimeout(() => {
          this.props.history.push('/list-coupons');
        }, 2000);
      } else {
        console.log('Unexpected response:', response);
        this.setState({ submissionStatus: 'error' });
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      this.setState({ submissionStatus: 'error' });
    }
  };

  render() {
    const { submissionStatus } = this.state;
    return (
      <div className="col-md-12">
        <form onSubmit={this.handleSubmit}>
          <div className="card">
            <div className="header">
              <h2>Edit Coupon</h2>
            </div>
            <div className="card-body">
              <div className="form-group">
                <label>Title</label>
                <input
                  type="text"
                  className="form-control"
                  name="title"
                  value={this.state.title}
                  onChange={this.handleChange}
                  placeholder="Title"
                />
              </div>
              <div className="form-group">
                <label>Code</label>
                <input
                  type="text"
                  className="form-control"
                  name="code"
                  value={this.state.code}
                  onChange={this.handleChange}
                  placeholder="Code"
                />
              </div>
              <div className="form-group">
                <label>Limit for User</label>
                <input
                  type="number"
                  className="form-control"
                  name="limit_for_user"
                  value={this.state.limit_for_user}
                  onChange={this.handleChange}
                  placeholder="Limit for User"
                />
              </div>
              <div className="form-group">
                <label>Discount Type</label>
                <select
                  className="form-control"
                  name="discount_type"
                  value={this.state.discount_type}
                  onChange={this.handleChange}
                >
                  <option value="amount">Amount</option>
                  <option value="percentage">Percentage</option>
                </select>
              </div>
              <div className="form-group">
                <label>Discount Amount</label>
                <input
                  type="number"
                  className="form-control"
                  name="discount_amount"
                  value={this.state.discount_amount}
                  onChange={this.handleChange}
                  placeholder="Discount Amount"
                />
              </div>
              <div className="form-group">
                <label>Minimum Purchase</label>
                <input
                  type="number"
                  className="form-control"
                  name="minimum_purchase"
                  value={this.state.minimum_purchase}
                  onChange={this.handleChange}
                  placeholder="Minimum Purchase"
                />
              </div>
              <div className="form-group">
                <label>Start Date</label>
                <input
                  type="datetime-local"
                  className="form-control"
                  name="start_date"
                  value={this.state.start_date}
                  onChange={this.handleChange}
                />
              </div>
              <div className="form-group">
                <label>Expire Date</label>
                <input
                  type="datetime-local"
                  className="form-control"
                  name="expire_date"
                  value={this.state.expire_date}
                  onChange={this.handleChange}
                />
              </div>
              {submissionStatus === 'success' && (
                <div className="alert alert-success" role="alert">
                  Coupon updated successfully!
                </div>
              )}
              {submissionStatus === 'error' && (
                <div className="alert alert-danger" role="alert">
                  Error updating coupon. Please try again.
                </div>
              )}
              <button className="btn btn-primary">
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default withRouter(EditCoupon);
